<template>
  <b-row>
    <b-col sm="2"><label :for="dbfield+'_input'">{{metadata.label}}:</label></b-col>
    <b-col sm="10">
      <b-form-textarea :id="dbfield+'_input'" size="sm" :placeholder="metadata.label"
                        :value="value" v-on:input="$emit('input', $event)" rows="3"
                        :plaintext="read_only"></b-form-textarea>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentTextarea',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      tvalue: {}
    }
  },
  computed: {
    ...mapState({
      'user': 'user'
    }),
    read_only: function () {
      var readOnly = false
      if (this.metadata.read_only) readOnly = true
      if (this.metadata.edit_roles) {
        if (!this.user) return true
        for (var i in this.metadata.edit_roles) {
          if ((this.user.roles.indexOf('_admin') !== -1) ||
            (this.user.roles.indexOf(this.metadata.edit_roles[i]) !== -1)) {
            return readOnly
          }
        }
        return true
      } else {
        return readOnly
      }
    }
  },
  mounted () {
    if (this.value) {
      this.tvalue = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'tvalue', val)
      this.$emit('valuechange', val)
    }
  }
}
</script>
